<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>棋盘配置修改</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="importProbUploadSuccess"
                :headers="headers"
              >
                <el-button v-permisaction="['config:slotWeightCfg:importProb']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:slotWeightCfg:exportProb']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData"
              >导出</el-button>
            </el-col>
          </el-row>
        </div>

        <el-dialog
          title="提示"
          :visible.sync="confirmSaveTempLate"
          width="30%"
          :show-close="false"
        >
          <el-form ref="form" :model="template" label-width="80px">
            <el-form-item label="模板名称">
              <el-input v-model="template.name" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="confirmSaveTempLate = false">取 消</el-button>
            <el-button type="primary" @click="confirmSaveAsTemp">确 定</el-button>
          </span>
        </el-dialog>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="等级">
              <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="等级" />
            </el-form-item>
            <el-form-item>
              <el-button type="text" @click="dialogFormVisibleArr[index].visible = true">关卡操作</el-button>
              <el-drawer direction="rtl" title="关卡操作" :before-close="(d)=>{return handleClose(d, index)}" size="1400px" :visible="dialogFormVisibleArr[index].visible" @close="confirm(index)" @opened="openWeight(index, item.levelId)">
                <el-select v-model="item.template_id" clearable size="mini" placeholder="请选择模板" style="margin-right: 10px" @change="v=>templateChange(v,index)">
                  <el-option
                    v-for="item in templdateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-button v-if="item.template_id > 0" v-permisaction="['config:slotWeightCfg:add']" type="primary" size="mini" @click.stop="saveTemp(item,item.template_id)">保存当前模板</el-button>
                <el-button v-permisaction="['config:slotWeightCfg:add']" type="success" size="mini" @click.stop="saveAsTemp(item)">另存为新模板</el-button>
                <el-button v-if="item.template_id > 0" v-permisaction="['config:slotWeightCfg:add']" type="warning" size="mini" @click.stop="saveAsTemp(item, item.template_id)">重命名</el-button>
                <el-row v-for="(pro, pIndex) in item.pro" :key="pIndex" style="margin-top: 10px;">
                  <el-form-item label="位置">
                    <el-input v-model.number="pro.id" readonly style="width: 100px" placeholder="自动生成" />
                  </el-form-item>
                  <el-form-item label="类型">
                    <el-select v-model="pro.type" placeholder="请选择类型" :disabled="!chnageTypeArr.includes(pro.id)" @change="(v)=>{selectTypeChange(v,index, pIndex)}">
                      <el-option v-for="(item, index) in selectType" :key="index" :label="item.title" :value="item.id" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="事件操作">
                    <el-button type="text" @click="dialogEventFormVisibleArr[index][pIndex]['visible'] = true">编辑</el-button>
                    <el-dialog title="事件" width="750px" :visible.sync="dialogEventFormVisibleArr[index][pIndex].visible" append-to-body>
                      <el-form :inline="true">
                        <el-row v-for="(e,i) in pro.event" :key="i">
                          <el-form-item style="margin-top: 10px;" label="事件ID">
                            <el-input v-model.number="e.eventId" readonly style="width: 100px" :prop="'formData.' +index +'.pro.event.i.eventId'" autocomplete="off" />
                          </el-form-item>
                          <el-form-item style="margin-top: 10px;" :label="getVTitle(e.eventId)">
                            <el-input v-model.number="e.v" readonly style="width: 100px" :prop="'formData.' +index +'.pro.event.'+i+'.v'" autocomplete="off" />
                          </el-form-item>
                          <el-form-item label="奖励类型" style="margin-top: 10px;">
                            <el-select v-model.number="e.rewardId" disabled style="width: 100px" :prop="'formData.' +index +'.event.'+i+'.rewardId'" placeholder="请选择">
                              <el-option
                                v-for="(item, index) in rewardType"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </el-form-item>
                          <el-form-item label="奖励数量" style="margin-top: 10px;">
                            <el-input v-model.number="e.rewardNum" readonly style="width: 100px" :prop="'formData.' +index +'.pro.event.'+i+'.rewardNum'" placeholder="奖励数量" />
                          </el-form-item>
                        </el-row>
                      </el-form>
                      <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogEventFormVisibleArr[index][pIndex].visible = false">取 消</el-button>
                        <el-button type="primary" @click="dialogEventFormVisibleArr[index][pIndex].visible = false">确 定</el-button>
                      </div>
                    </el-dialog>
                  </el-form-item>
                  <el-form-item label="权重">
                    <el-input v-model.number="pro.v" readonly style="width: 100px" placeholder="权重" />
                  </el-form-item>
                  <el-form-item label="善款目标权重">
                    <el-input v-model.number="pro.rentV" style="width: 80px" placeholder="善款目标权重" />
                  </el-form-item>
                  <el-form-item label="icon">
                    <el-input v-model.number="pro.iconId" style="width: 100px" placeholder="icon" />
                  </el-form-item>
                  <el-form-item label="描述">
                    <el-input v-model="pro.desc" placeholder="描述" />
                  </el-form-item>
                  <!--                  <el-form-item>-->
                  <!--                    <el-button v-permisaction="['config:slotWeightCfg:add']" type="danger" @click="del(index, pIndex)">删除</el-button>-->
                  <!--                  </el-form-item>-->
                </el-row>
                <el-form-item style="margin-top: 10px">
                  <el-button v-if="item.pro.length < 40" v-permisaction="['config:slotWeightCfg:add']" type="primary" @click="add(index)">+关卡</el-button>
                </el-form-item>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogFormVisibleArr[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="confirm(index)">确 定</el-button>
                </div>
              </el-drawer>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="item.desc" placeholder="描述" />
            </el-form-item>
          </el-row>
          <!--          <el-form-item>-->
          <!--            <el-button v-permisaction="['config:slotWeightCfg:add']" type="primary" @click="addLevel()">+</el-button>-->
          <!--          </el-form-item>-->
          <el-button v-permisaction="['config:slotWeightCfg:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import {
  getSlotWeightCfgList,
  updateSlotWeightCfg,
  getChessBoardType,
  getRewardType,
  exportSlotWeightCfg,
  importSlotWeightCfg,
  exportSlotWeightCfgMoney,
  saveSlotWeightCfgTemp, getSlotEventCfgTempLateList, getSlotEventCfgList
} from '@/api/config/slot'
import { getToken } from '@/utils/auth'
export default {
  name: 'SlotWeightCfg',
  data() {
    return {
      template: {
        id: 0,
        name: '',
        levelId: 0,
        pro: []
      },
      chnageTypeArr: [1, 6, 11, 16, 21, 26, 31, 36],
      tempItem: {},
      tabIndex: -1,
      confirmSaveTempLate: false,
      loading: false,
      templdateList: [],
      typeArr: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
      disbaleArr: [1, 2, 3, 17, 18, 19, 20, 21, 22, 23, 24],
      readonlyArr: [1, 2, 20, 21, 19, 22],
      dialogFormVisibleArr: [{ visible: false }],
      dialogEventFormVisibleArr: [
        [{ visible: false }]
      ],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      getVTitle(v) {
        if (v === 3) {
          return '点数'
        }
        return '权重'
      },
      selectType: [],
      rewardType: [],
      eventData: {},
      formData: [
        {
          'levelId': 0,
          'desc': '描述',
          template_id: '',
          'pro': [
            {
              'type': 1,
              'v': 0,
              'event': [
                {
                  'eventId': 0,
                  'v': 1,
                  'rewardId': 0,
                  'rewardNum': 0
                }
              ],
              'iconId': 0,
              'rentV': 0
            }
          ]
        }
      ],
      formInline: [],
      enums: ['攻击', '偷袭', '体力', '护盾', '1个金币', '2个金币', '3个金币', '1个钱袋', '2个钱袋', '3个钱袋', '没有奖励', '活动物品1', '活动物品2', '活动物品3', '小玩法物品1', '小玩法物品2', '小玩法物品3', '一个偷', '两个偷', '一个打', '两个打']
    }
  },
  created() {
    this.getTables()
    this.getRewardTypeData()
    this.getChessBoardType()
  },
  methods: {
    handleClose(done, index) {
      this.dialogFormVisibleArr[index].visible = false
      done()
    },
    weightIsReadOnly(v) {
      if (this.typeArr.includes(v)) {
        return true
      }
      return false
    },
    isReadOnly(v) {
      if (this.readonlyArr.includes(v)) {
        return true
      }
      return false
    },
    isDisabled(v) {
      if (this.disbaleArr.includes(v)) {
        return true
      }
      return false
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.selectType.push({ 'title': res.data[i], 'id': parseInt(i) })
          }
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateSlotWeightCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addLevel() {
      this.formData.push({
        'levelId': 0,
        'desc': '描述',
        'pro': []
      })
      const index = this.formData.length - 1
      this.dialogFormVisibleArr.push({ visible: false })
      this.$set(this.dialogEventFormVisibleArr, index, [])
      const pro = []
      for (let i = 1; i <= 40; i++) {
        pro.push({
          id: i,
          'type': 1,
          'v': 0,
          'desc': '描述',
          'event': []
        })
        this.dialogEventFormVisibleArr[index].push({ visible: false })
      }
      this.formData[index].pro = pro
    },
    confirm(index) {
      this.dialogFormVisibleArr[index].visible = false
      this.onSubmit()
    },
    saveTemp(item, templateId) {
      this.$confirm('该操作将影响到所有使用该模板的棋盘，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再看看',
        type: 'warning'
      }).then(() => {
        const { levelId, pro } = item
        this.template.id = templateId
        this.template.pro = pro
        this.template.levelId = levelId
        const data = JSON.stringify(this.template)
        this.saveAsTemp2(templateId, levelId, data)
      })
    },
    saveAsTemp(item, templateId = 0) {
      if (templateId > 0) {
        let templdateName = ''

        for (const i in this.templdateList) {
          const val = this.templdateList[i]
          if (val.value === templateId) {
            templdateName = val.label
            break
          }
        }
        if (!templdateName) {
          this.msgError('获取失败')
          return false
        }

        this.template.name = templdateName
        this.template.id = templateId
      }
      this.tempItem = item
      this.confirmSaveTempLate = true
    },
    confirmSaveAsTemp() {
      if (!this.template.name) {
        this.msgError('请输入模板名称')
        return false
      }
      this.confirmSaveTempLate = false
      const { levelId, pro } = this.tempItem
      this.template.levelId = levelId
      this.template.pro = pro
      const data = JSON.stringify(this.template)
      this.saveAsTemp2(this.template.id, levelId, data)
    },
    saveAsTemp2(isCreate, id, data) {
      saveSlotWeightCfgTemp({ id: isCreate, data: data }).then(res => {
        if (res.code === 200) {
          this.template = { name: '', id: 0 }
          this.msgSuccess(res.msg)
          this.openWeight(0, id)
          // this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add(index) {
      // console.log(this.formData[index])
      if (this.formData[index].pro.length > 40) {
        this.msgError('已达上限')
        return false
      }
      this.formData[index].pro.push({
        'type': 1,
        'v': 0,
        'desc': '描述',
        'event': [
          {
            'id': 1,
            'eventId': 1,
            'v': 0,
            'rewardId': 0,
            'rewardNum': 0
          }, {
            'id': 2,
            'eventId': 2,
            'v': 0,
            'rewardId': 0,
            'rewardNum': 0
          }
        ],
        'iconId': 0
      })
      this.dialogEventFormVisibleArr[index].push({ visible: false })
    },
    del(index, key) {
      this.formData[index].pro = this.formData[index].pro.filter((item, i) => {
        return i !== key
      })
    },
    getTables() {
      getSlotWeightCfgList(this.queryParams).then(res => {
        this.total = res.data.count
        res.data.list.forEach((item, index) => {
          Vue.set(this.dialogFormVisibleArr, index, { visible: false })
          const proArr = []
          item.pro.forEach(pro => {
            proArr.push({ visible: false })
          })
          Vue.set(this.dialogEventFormVisibleArr, index, proArr)
        })
        this.formData = res.data.list
      })
    },
    exportData() {
      exportSlotWeightCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response, file, fileList) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importSlotWeightCfg({ path: response.data.path, importType: 1 }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importMoneyUploadSuccess(response, file, fileList) {
      importSlotWeightCfg({ path: response.data.path, ImportType: 2 }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportMoney() {
      exportSlotWeightCfgMoney().then(res => {
        console.log(res)
      })
    },
    addEvent(index) {
      this.formData[index].pro.event.push({
        'eventId': 2,
        'v': 0
      })
    },
    removeEvent(index, key) {
      this.formData[index].slotPro.event = this.formData[index].slotPro.event.filter((item, k) => {
        return key !== k
      })
    },
    selectTypeChange(val, index, pIndex) {
      this.formData[index].pro[pIndex].v = this.eventData[val].v
      this.formData[index].pro[pIndex].event = this.eventData[val].event
    },
    openWeight(index, levelId) {
      if (levelId > 0) {
        getSlotEventCfgList({ levelId: levelId }).then(res => {
          if (res.code === 200 && res.data.list.length > 0) {
            const data = res.data.list[0]
            data.pro.forEach(item => {
              this.eventData[item.type] = {
                v: item.v,
                event: item.event
              }
            })
          }
        })

        getSlotEventCfgTempLateList({ levelId: levelId }).then(res => {
          if (res.code === 200) {
            this.templdateList = []
            res.data.forEach(res => {
              this.templdateList.push({ label: res.name, value: res.id, pro: res.pro })
            })
          } else {
            this.msgError(res.msg)
          }
        })
      }
    },
    templateChange(value, index) {
      if (!value) {
        return
      }
      let pro = []
      for (const i in this.templdateList) {
        const val = this.templdateList[i]
        if (val.value === value) {
          pro = val.pro
          break
        }
      }

      if (!pro) {
        this.msgError('选择出错!')
        return
      }

      this.formData[index].pro = pro
    }
  }
}
</script>

<style scoped>
</style>
